<template>
  <div id="paxpage" ref="paxpage" >
   
     <div class="container" v-if="true">
                <div class="row">
                    <div class="col-lg-8 col-xl-9">
                        <div class="mb-5 shadow-soft bg-white rounded-sm">
                            <div class="py-3 px-4 px-xl-12 border-bottom">
                                <ul class="list-group flex-nowrap overflow-auto overflow-md-visble list-group-horizontal list-group-borderless flex-center-between pt-1">
                                    <li class="list-group-item text-center flex-shrink-0 flex-xl-shrink-1">
                                        <div class="flex-content-center mb-3 width-40 height-40 bg-primary border-width-2 border border-primary text-white mx-auto rounded-circle">
                                            1
                                        </div>
                                        <div class="text-primary">Customer information</div>
                                    </li>
                                    <li class="list-group-item text-center flex-shrink-0 flex-xl-shrink-1">
                                        <div class="flex-content-center mb-3 width-40 height-40 border  border-width-2 border-gray mx-auto rounded-circle">
                                            2
                                        </div>
                                        <div class="text-gray-1">Payment information</div>
                                    </li>
                                    <li class="list-group-item text-center flex-shrink-0 flex-md-shrink-1">
                                        <div class="flex-content-center mb-3 width-40 height-40 border  border-width-2 border-gray mx-auto rounded-circle">
                                            3
                                        </div>
                                        <div class="text-gray-1">Booking is confirmed!</div>
                                    </li>
                                </ul>
                            </div>
                             <ValidationObserver class="passenger-info-page" v-slot="{ handleSubmit, invalid}">
              <!-- @submit.prevent="handleSubmit(paxPageSubmitted)" -->
              <form @submit.prevent="handleSubmit(paxPageSubmitted)">
                <!-- <div v-if="this.sHotelSearchObj"></div> -->

                <!-- {{pax}} -->

                <div >
                  <!-- class="passenger-card-wrapper" -->
                  <!-- <cMLSelFlightInfo
                    :isPaxPage="true"
                    v-if="sHotelSearchObj && sHotelSearchObj.trip==3 && selFlight&&selFlight.length!=0"
                    :selectedflightList="selFlight"
                  /> -->

                  <!-- {{passenger.paxList}}   -->
                  <!-- {{sHotelSearchObj}} -->
                  <!-- {{'pax '+JSON.stringify(paxObj[0].dob)}} -->
                  <div >
                    <div>
                      <div
                        :id="'scrollTo'+index"
                        :ref="'scrollTo'+index"
                        v-for="(pax,index) in passenger.paxList.slice(0,passenger.paxList.length-2)"
                        :key="'pax'+index"
                      >
                        <cPax
                          v-if="countryResponse!=null"
                          @caughtError="getErrorPax"
                          @getMblEmailFromRes="getEmailAndMblNo"
                          @getDob="getSelectedDob"
                          @getSelExpryDate="getSelectedExpryDate"
                          @getMblcode="getContactMblcode"
                          @getContactName="onAssFnameToContact"
                          @getIsDisable="toGetIsDisable"
                          :citizen="sHotelSearchObj?sHotelSearchObj.areaObj.cityName:null"
                          :paxIndex="index"
                          :pax="pax"
                          :rule="getRules(pax.paxType)"
                          :paxSubmit="paxSubmitted"
                        />
                      </div>

                      <cContact
                        v-if="passenger.paxList[passenger.paxList.length-2] && countryResponse!=null"
                        :contDetail="passenger.paxList[passenger.paxList.length-2]"
                        :rule="getRules(passenger.paxList[passenger.paxList.length-2].paxType)"
                      />
                      <CAlert v-if="valMsg!=null" show color="danger">{{valMsg}}</CAlert>
                      <CCard class="info-card">
                        <div class="form-title">
                          <h2>{{$t('passInfo.bookRef')}}</h2>
                        </div>
                        <CCardBody class="individual-info pt-25px border-none">
                          <div class="custom-input-pass">
                            <!-- :rules="'max:30'" -->
                            <ValidationProvider v-slot="{ errors }">
                              <input
                                v-if="passenger.paxList[passenger.paxList.length-1]"
                                placeholder="Enter agent reference here ( optional )"
                                class="form-control"
                                :maxlength="100"
                                v-model="passenger.paxList[passenger.paxList.length-1].bookingRef"
                              />
                              <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                              </div>
                            </ValidationProvider>
                          </div>
                        </CCardBody>
                      </CCard>

                      <!-- <cSelFlightInfo :isPaxPage="true"
                                                                                v-if="selFlight.ob.obFlight.length>0 || selFlight.ib.ibFlight.length>0"
                                                                                :selflightObj="selFlight"
                      />-->
                      <!-- <cPerPaxPriceInfo
                                                                                v-if="selFlight.ob.obFlight.length>0 || selFlight.ib.ibFlight.length>0"
                                                                                :selflightObj="selFlight"
                      />-->

                      <!-- Totalpriceinfo Component -->
                      <!-- <cTotalPriceInfo
                                                                                v-if="selFlight.ob.obFlight.length>0 || selFlight.ib.ibFlight.length>0"
                                                                                :selflightObj="selFlight"
                      />-->
                      <!--                                            <div class="tc-text">Lorem ipsum dolor sit amet, consectetur adipisicing-->
                      <!--                                                elit. Architecto,<a @click="onToggleFRModal">View Fare Rules</a>-->
                      <!--                                                eveniet.-->
                      <!--                                            </div>-->

                      <!-- {{invalid||toDisable}} -->
                      <button @click="paxSubmitted=true">Pay</button>
                      <!-- <cHotelFooter
                        v-if="sHotelSearchObj "
                        :isSticky="false"
                        :isFlightSel="sPricingRoomResult?true:false"
                        :tooltipText="(invalid||toDisable)?$t('passInfo.paxPageBtnTooltip'):null"
                        :buttonName="$t('passInfo.continue')"
                        :selFlight="selFlight"
                        :type="true"
                        @onContinue="paxSubmitted=true"
                      /> -->

                      <cMLFlightFooter
                        v-if="sHotelSearchObj && sHotelSearchObj.trip==3"
                        :isSticky="false"
                        :isFlightSel="selFlight && selFlight.length!=0"
                        :buttonName="$t('passInfo.continue')"
                        :selFlight="selFlight"
                        :type="true"
                        @onContinue="paxSubmitted=true"
                      />
                      <!-- <CRow>
                                                                            <CCol class="primary-cta-btn">
                                                                                <CButton  type="submit" >
                                                                                    {{$t('passInfo.pay')}}
                                                                                </CButton>
                                                                            </CCol>
                      </CRow>-->
                    </div>
                  </div>
                </div>
              </form>
                <!-- <cHotelFooter
                        v-if="sHotelSearchObj "
                        :isSticky="false"
                        :isFlightSel="sPricingRoomResult?true:false"
                        :tooltipText="(invalid||toDisable)?$t('passInfo.paxPageBtnTooltip'):null"
                        :buttonName="$t('passInfo.continue')"
                        :selFlight="selFlight"
                        :type="true"
                        @onContinue="paxSubmitted=true"
                      /> -->

            </ValidationObserver>
                            
                        </div>
                        <div class="mb-5 shadow-soft bg-white rounded-sm">
                            <div class="py-3 px-4 px-xl-12 border-bottom">
                                <ul class="list-group flex-nowrap overflow-auto overflow-md-visble list-group-horizontal list-group-borderless flex-center-between pt-1">
                                    <li class="list-group-item text-center flex-shrink-0 flex-xl-shrink-1">
                                        <div class="flex-content-center mb-3 width-40 height-40 border  border-width-2 border-gray mx-auto rounded-circle">
                                            1
                                        </div>
                                        <div class="text-gray-1">Customer information</div>
                                    </li>
                                    <li class="list-group-item text-center flex-shrink-0 flex-xl-shrink-1">
                                        <div class="flex-content-center mb-3 width-40 height-40 bg-primary border-width-2 border border-primary text-white mx-auto rounded-circle">
                                            2
                                        </div>
                                        <div class="text-primary">Payment information</div>
                                    </li>
                                    <li class="list-group-item text-center flex-shrink-0 flex-md-shrink-1">
                                        <div class="flex-content-center mb-3 width-40 height-40 border  border-width-2 border-gray mx-auto rounded-circle">
                                            3
                                        </div>
                                        <div class="text-gray-1">Booking is confirmed!</div>
                                    </li>
                                </ul>
                            </div>
                            <div class="pt-4 pb-5 px-5">
                                <h5 id="scroll-description" class="font-size-21 font-weight-bold text-dark mb-4">
                                    Your Card Information
                                </h5>
                                <ul class="nav nav-classic nav-choose border-0 nav-justified border mx-n3" role="tablist">
                                    <li class="nav-item mx-3 mb-4 mb-md-0">
                                        <a class="rounded py-5 border-width-2 border nav-link font-weight-medium active" id="pills-one-example2-tab" data-toggle="pill" href="#pills-one-example2" role="tab" aria-controls="pills-one-example2" aria-selected="true">
                                            <div class="height-25 width-25 flex-content-center bg-primary rounded-circle position-absolute left-0 top-0 ml-2 mt-2">
                                                <i class="flaticon-tick text-white font-size-15"></i>
                                            </div>
                                            <div class="d-md-flex justify-content-md-center align-items-md-center flex-wrap">
                                                <img class="img-fluid mb-3" src="@imgPathB2c/b2c/img/199x35/img1.jpg" alt="Image-Description">
                                                <div class="w-100 text-dark">Payment with credit card</div>
                                            </div>
                                        </a>
                                    </li>
                                    <li class="nav-item mx-3">
                                        <a class="rounded py-5 border-width-2 border nav-link font-weight-medium" id="pills-two-example2-tab" data-toggle="pill" href="#pills-two-example2" role="tab" aria-controls="pills-two-example2" aria-selected="false">
                                            <div class="height-25 width-25 flex-content-center bg-primary rounded-circle position-absolute left-0 top-0 ml-2 mt-2">
                                                <i class="flaticon-tick text-white font-size-15"></i>
                                            </div>
                                            <div class="d-md-flex justify-content-md-center align-items-md-center flex-wrap">
                                                <img class="img-fluid mb-3" src="@imgPathB2c/b2c/img/199x35/img2.jpg" alt="Image-Description">
                                                <div class="w-100 text-dark">Payment with paypal</div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                               
                                <div class="tab-content">
                                    <div class="tab-pane fade pt-8 show active" id="pills-one-example2" role="tabpanel" aria-labelledby="pills-one-example2-tab">
                                        <!-- Payment Form -->
                                        <form class="js-validate">
                                            <div class="row">
                                                <!-- Input -->
                                                <div class="col-sm-6 mb-4">
                                                    <div class="js-form-message">
                                                        <label class="form-label">
                                                            Card Holder Name
                                                        </label>

                                                        <input type="text" class="form-control" name="Cardname" placeholder="" aria-label="" required
                                                        data-msg="Please enter card holder name."
                                                        data-error-class="u-has-error"
                                                        data-success-class="u-has-success">
                                                    </div>
                                                </div>
                                                <!-- End Input -->

                                                <!-- Input -->
                                                <div class="col-sm-6 mb-4">
                                                    <div class="js-form-message">
                                                        <label class="form-label">
                                                            Card Number
                                                        </label>

                                                        <input type="number" class="form-control" name="Cardnumber" placeholder="" aria-label="" required
                                                        data-msg="Please enter card number."
                                                        data-error-class="u-has-error"
                                                        data-success-class="u-has-success">
                                                    </div>
                                                </div>
                                                <!-- End Input -->

                                                <div class="w-100"></div>

                                                <!-- Input -->
                                                <div class="col-sm-6 mb-4">
                                                    <div class="row">
                                                        <div class="col-sm-6 mb-4 mb-md-0">
                                                            <div class="js-form-message">
                                                                <label class="form-label">
                                                                    Expiry Month
                                                                </label>

                                                                <input type="number" class="form-control" name="Expirymonth" placeholder="" aria-label="" required
                                                                data-msg="Please enter expiry month."
                                                                data-error-class="u-has-error"
                                                                data-success-class="u-has-success">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="js-form-message">
                                                                <label class="form-label">
                                                                    Expiry Year
                                                                </label>

                                                                <input type="number" class="form-control" name="Expiryyear" placeholder="" aria-label="" required
                                                                data-msg="Please enter expiry year."
                                                                data-error-class="u-has-error"
                                                                data-success-class="u-has-success">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- End Input -->

                                                <!-- Input -->
                                                <div class="col-sm-6 mb-4">
                                                    <div class="js-form-message">
                                                        <label class="form-label">
                                                            CCV
                                                        </label>

                                                        <input type="number" class="form-control" name="ccvnumber" placeholder="" aria-label="" required
                                                        data-msg="Please enter ccv number."
                                                        data-error-class="u-has-error"
                                                        data-success-class="u-has-success">
                                                    </div>
                                                </div>
                                                <!-- End Input -->

                                                <div class="w-100"></div>

                                                <div class="col">
                                                    <!-- Checkbox -->
                                                    <div class="js-form-message mb-5">
                                                        <div class="custom-control custom-checkbox d-flex align-items-center text-muted">
                                                            <input type="checkbox" class="custom-control-input" id="termsCheckbox" name="termsCheckbox" required
                                                            data-msg="Please accept our Terms and Conditions."
                                                            data-error-class="u-has-error"
                                                            data-success-class="u-has-success">
                                                            <label class="custom-control-label" for="termsCheckbox">
                                                                <small>
                                                                    By continuing, you agree to the
                                                                    <a class="link-muted" href="../pages/terms.html">Terms and Conditions</a>
                                                                </small>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <!-- End Checkbox -->
                                                    <button type="submit" class="btn btn-primary w-100 rounded-sm transition-3d-hover font-size-16 font-weight-bold py-3">CONFIRM BOOKING</button>
                                                </div>
                                            </div>
                                        </form>
                                        <!-- End Payment Form -->
                                    </div>

                                    <div class="tab-pane fade pt-8" id="pills-two-example2" role="tabpanel" aria-labelledby="pills-two-example2-tab">
                                        <form class="js-validate">
                                            <!-- Login -->
                                            <div id="login" data-target-group="idForm">
                                                <!-- Form Group -->
                                                <div class="form-group">
                                                    <div class="js-form-message js-focus-state">
                                                        <label class="sr-only" for="signinEmail">Email</label>
                                                        <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text" id="signinEmailLabel">
                                                                    <span class="fas fa-user"></span>
                                                                </span>
                                                            </div>
                                                            <input type="email" class="form-control" name="email" id="signinEmail" placeholder="Email" aria-label="Email" aria-describedby="signinEmailLabel" required
                                                            data-msg="Please enter a valid email address."
                                                            data-error-class="u-has-error"
                                                            data-success-class="u-has-success">
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- End Form Group -->

                                                <!-- Form Group -->
                                                <div class="form-group mb-4">
                                                    <div class="js-form-message js-focus-state">
                                                        <label class="sr-only" for="signinPassword">Password</label>
                                                        <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text" id="signinPasswordLabel">
                                                                    <span class="fas fa-lock"></span>
                                                                </span>
                                                            </div>
                                                            <input type="password" class="form-control" name="password" id="signinPassword" placeholder="Password" aria-label="Password" aria-describedby="signinPasswordLabel" required
                                                            data-msg="Your password is invalid. Please try again."
                                                            data-error-class="u-has-error"
                                                            data-success-class="u-has-success">
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- End Form Group -->

                                                <div class="mb-2">
                                                    <button type="submit" class="btn btn-block btn-primary transition-3d-hover">Login</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <!-- End Tab Content -->
                            </div>
                        </div>
                        <div class="mb-5 shadow-soft bg-white rounded-sm">
                            <div class="py-6 px-5 border-bottom">
                                <div class="flex-horizontal-center">
                                    <div class="height-50 width-50 flex-shrink-0 flex-content-center bg-primary rounded-circle">
                                        <i class="flaticon-tick text-white font-size-24"></i>
                                    </div>
                                    <div class="ml-3">
                                        <h3 class="font-size-18 font-weight-bold text-dark mb-0 text-lh-sm">
                                            Thank You. Your Booking Order is Confirmed Now.
                                        </h3>
                                        <p class="mb-0">A confirmation email has been sent to your provided email address.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-4 pb-5 px-5 border-bottom">
                                <h5 id="scroll-description" class="font-size-21 font-weight-bold text-dark mb-2">
                                    Traveler Information
                                </h5>
                                <!-- Fact List -->
                                <ul class="list-unstyled font-size-1 mb-0 font-size-16">
                                    <li class="d-flex justify-content-between py-2">
                                        <span class="font-weight-medium">Booking number</span>
                                        <span class="text-secondary text-right">5784-BD245</span>
                                    </li>

                                    <li class="d-flex justify-content-between py-2">
                                        <span class="font-weight-medium">First name</span>
                                        <span class="text-secondary text-right">Jessica</span>
                                    </li>

                                    <li class="d-flex justify-content-between py-2">
                                        <span class="font-weight-medium">Last name</span>
                                        <span class="text-secondary text-right">Brown</span>
                                    </li>

                                    <li class="d-flex justify-content-between py-2">
                                        <span class="font-weight-medium">E-mail address</span>
                                        <span class="text-secondary text-right">Info@Jessica.com</span>
                                    </li>

                                    <li class="d-flex justify-content-between py-2">
                                        <span class="font-weight-medium">Street Address and number</span>
                                        <span class="text-secondary text-right">353 Third floor Avenue</span>
                                    </li>

                                    <li class="d-flex justify-content-between py-2">
                                        <span class="font-weight-medium">Town / City</span>
                                        <span class="text-secondary text-right">Paris,France</span>
                                    </li>

                                    <li class="d-flex justify-content-between py-2">
                                        <span class="font-weight-medium">ZIP code</span>
                                        <span class="text-secondary text-right">75800-875</span>
                                    </li>

                                    <li class="d-flex justify-content-between py-2">
                                        <span class="font-weight-medium">Country</span>
                                        <span class="text-secondary text-right">United States of america</span>
                                    </li>
                                </ul>
                                <!-- End Fact List -->
                            </div>
                            <div class="pt-4 pb-5 px-5 border-bottom">
                                <h5 id="scroll-description" class="font-size-21 font-weight-bold text-dark mb-3">
                                    Payment
                                </h5>
                                <p class="">
                                    Praesent dolor lectus, rutrum sit amet risus vitae, imperdiet cursus neque. Nulla tempor nec lorem eu suscipit. Donec dignissim lectus a nunc molestie consectetur. Nulla eu urna in nisi adipiscing placerat. Nam vel scelerisque magna. Donec justo urna,  posuere ut dictum quis.
                                </p>

                                <a href="#" class="text-underline text-primary">Payment is made by Credit Card Via Paypal.</a>
                            </div>
                            <div class="pt-4 pb-5 px-5">
                                <h5 id="scroll-description" class="font-size-21 font-weight-bold text-dark mb-3">
                                    View Booking Details
                                </h5>
                                <p class="">
                                    Praesent dolor lectus, rutrum sit amet risus vitae, imperdiet cursus neque. Nulla tempor nec lorem eu suscipit. Donec dignissim lectus a nunc molestie consectetur. Nulla eu urna in nisi adipiscing placerat. Nam vel scelerisque magna. Donec justo urna,  posuere ut dictum quis.
                                </p>

                                <a href="#" class="text-underline text-primary">https://www.mytravel.com/booking-details/?=f4acb19f-9542-4a5c-b8ee</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-xl-3">
                        <div class="shadow-soft bg-white rounded-sm">
                            <div class="pt-5 pb-3 px-5 border-bottom">
                                <a href="#" class="d-block mb-3">
                                    <img class="img-fluid rounded-xs" src="@imgPathB2c/b2c/img/240x160/img3.jpg" alt="Image-Description">
                                </a>
                                <a href="#" class="text-dark font-weight-bold pr-xl-1">Park Avenue Baker Street London</a>
                                <div class="my-1 flex-horizontal-center text-gray-1">
                                    <i class="icon flaticon-pin-1 mr-2 font-size-15"></i> United Kingdom
                                </div>
                            </div>
                            <!-- Basics Accordion -->
                            <div id="basicsAccordion">
                                <!-- Card -->
                                <div class="card rounded-0 border-top-0 border-left-0 border-right-0">
                                    <div class="card-header card-collapse bg-transparent border-0" id="basicsHeadingOne">
                                        <h5 class="mb-0">
                                            <button type="button" class="btn btn-link border-0 btn-block d-flex justify-content-between card-btn py-3 px-4 font-size-17 font-weight-bold text-dark"
                                                data-toggle="collapse"
                                                data-target="#basicsCollapseOne"
                                                aria-expanded="true"
                                                aria-controls="basicsCollapseOne">
                                                Booking Detail

                                                <span class="card-btn-arrow font-size-14 text-dark">
                                                    <i class="fas fa-chevron-down"></i>
                                                </span>
                                            </button>
                                        </h5>
                                    </div>
                                    <div id="basicsCollapseOne" class="collapse show"
                                        aria-labelledby="basicsHeadingOne"
                                        data-parent="#basicsAccordion">
                                        <div class="card-body px-4 pt-0">
                                            <!-- Fact List -->
                                            <ul class="list-unstyled font-size-1 mb-0 font-size-16">
                                                <li class="d-flex justify-content-between py-2">
                                                    <span class="font-weight-medium">22 Sep 2019 - 23 Sep 2019 <br>
                                                        <span class="text-gray-1 font-weight-normal">1 x Comfort Room</span>
                                                    </span>
                                                    <span class="text-secondary"><a href="#" class="text-underline">Edit</a></span>
                                                </li>
                                                <li class="d-flex justify-content-between py-2">
                                                    <span class="font-weight-medium">Stay</span>
                                                    <span class="text-secondary">7 Night</span>
                                                </li>

                                                <li class="d-flex justify-content-between py-2">
                                                    <span class="font-weight-medium">Room</span>
                                                    <span class="text-secondary">2 Room</span>
                                                </li>

                                                <li class="d-flex justify-content-between py-2">
                                                    <span class="font-weight-medium">Adult</span>
                                                    <span class="text-secondary">4</span>
                                                </li>
                                            </ul>
                                            <!-- End Fact List -->
                                        </div>
                                    </div>
                                </div>
                                <!-- End Card -->

                                <!-- Card -->
                                <div class="card rounded-0 border-top-0 border-left-0 border-right-0">
                                    <div class="card-header card-collapse bg-transparent border-0" id="basicsHeadingTwo">
                                        <h5 class="mb-0">
                                            <button type="button" class="btn btn-link border-0 btn-block d-flex justify-content-between card-btn py-3 px-4 font-size-17 font-weight-bold text-dark"
                                                data-toggle="collapse"
                                                data-target="#basicsCollapseTwo"
                                                aria-expanded="true"
                                                aria-controls="basicsCollapseTwo">
                                                Extra

                                                <span class="card-btn-arrow font-size-14 text-dark">
                                                    <i class="fas fa-chevron-down"></i>
                                                </span>
                                            </button>
                                        </h5>
                                    </div>
                                    <div id="basicsCollapseTwo" class="collapse"
                                        aria-labelledby="basicsHeadingTwo"
                                        data-parent="#basicsAccordion">
                                        <div class="card-body px-4 pt-0">
                                            Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
                                        </div>
                                    </div>
                                </div>
                                <!-- End Card -->

                                <!-- Card -->
                                <div class="card rounded-0 border-top-0 border-left-0 border-right-0">
                                    <div class="card-header card-collapse bg-transparent border-0" id="basicsHeadingThree">
                                        <h5 class="mb-0">
                                            <button type="button" class="btn btn-link border-0 btn-block d-flex justify-content-between card-btn py-3 px-4 font-size-17 font-weight-bold text-dark"
                                                data-toggle="collapse"
                                                data-target="#basicsCollapseThree"
                                                aria-expanded="false"
                                                aria-controls="basicsCollapseThree">
                                                Coupon Code

                                                <span class="card-btn-arrow font-size-14 text-dark">
                                                    <i class="fas fa-chevron-down"></i>
                                                </span>
                                            </button>
                                        </h5>
                                    </div>
                                    <div id="basicsCollapseThree" class="collapse show"
                                        aria-labelledby="basicsHeadingThree"
                                        data-parent="#basicsAccordion">
                                        <div class="card-body px-4 pt-0 pb-4">
                                            <!-- Subscribe Form -->
                                            <form class="js-focus-state">
                                                <label class="sr-only" for="CouponCodeExample1">Coupon Code</label>
                                                <div class="input-group custom__input-group">
                                                    <input type="number" class="form-control" name="email" id="CouponCodeExample1" placeholder="" aria-label="" aria-describedby="CouponCodeExample2" required>
                                                    <div class="input-group-append ml-3">
                                                        <button class="btn btn-primary py-2" type="button" id="CouponCodeExample2">Apply</button>
                                                    </div>
                                                </div>
                                            </form>
                                            <!-- End Subscribe Form -->
                                        </div>
                                    </div>
                                </div>
                                <!-- End Card -->

                                <!-- Card -->
                                <div class="card rounded-0 border-top-0 border-left-0 border-right-0">
                                    <div class="card-header card-collapse bg-transparent border-0" id="basicsHeadingFour">
                                        <h5 class="mb-0">
                                            <button type="button" class="btn btn-link border-0 btn-block d-flex justify-content-between card-btn py-3 px-4 font-size-17 font-weight-bold text-dark"
                                                data-toggle="collapse"
                                                data-target="#basicsCollapseFour"
                                                aria-expanded="false"
                                                aria-controls="basicsCollapseFour">
                                                Payment

                                                <span class="card-btn-arrow font-size-14 text-dark">
                                                    <i class="fas fa-chevron-down"></i>
                                                </span>
                                            </button>
                                        </h5>
                                    </div>
                                    <div id="basicsCollapseFour" class="collapse show"
                                        aria-labelledby="basicsHeadingFour"
                                        data-parent="#basicsAccordion">
                                        <div class="card-body px-4 pt-0">
                                            <!-- Fact List -->
                                            <ul class="list-unstyled font-size-1 mb-0 font-size-16">
                                                <li class="d-flex justify-content-between py-2">
                                                    <span class="font-weight-medium">Subtotal</span>
                                                    <span class="text-secondary">€580,00</span>
                                                </li>

                                                <li class="d-flex justify-content-between py-2">
                                                    <span class="font-weight-medium">Extra Price</span>
                                                    <span class="text-secondary">€0,00</span>
                                                </li>

                                                <li class="d-flex justify-content-between py-2">
                                                    <span class="font-weight-medium">Tax</span>
                                                    <span class="text-secondary">0 %</span>
                                                </li>

                                                <li class="d-flex justify-content-between py-2 font-size-17 font-weight-bold">
                                                    <span class="font-weight-bold">Pay Amount</span>
                                                    <span class="">€580,00</span>
                                                </li>
                                            </ul>
                                            <!-- End Fact List -->
                                        </div>
                                    </div>
                                </div>
                                <!-- End Card -->
                            </div>
                            <!-- End Basics Accordion -->
                        </div>
                    </div>
                </div>
            </div>

    <div id="flight-result-wrapper" v-else>
      <div class="passenger-info-page">
        <div class="d-flex">
          <!-- {{pax}} -->
          <div class="left">
            <div class="passenger-card-wrapper">
              <cSelFlightInfo
                :isPaxPage="true"
                v-if="sHotelSearchObj && (sHotelSearchObj.trip==2 || sHotelSearchObj.trip==1) && selFlight&&selFlight.ob&&selFlight.ob.obFlight.length>0
                                                    ||selFlight&& selFlight.ib&&selFlight.ib.ibFlight.length>0"
                :selflightObj="selFlight"
              />
            </div>
            <ValidationObserver v-slot="{ handleSubmit, invalid}">
              <!-- @submit.prevent="handleSubmit(paxPageSubmitted)" -->
              <form @submit.prevent="handleSubmit(paxPageSubmitted)">
                <!-- <div v-if="this.sHotelSearchObj"></div> -->

                <!-- {{pax}} -->

                <div class="passenger-card-wrapper">
                  <cMLSelFlightInfo
                    :isPaxPage="true"
                    v-if="sHotelSearchObj && sHotelSearchObj.trip==3 && selFlight&&selFlight.length!=0"
                    :selectedflightList="selFlight"
                  />

                  <!-- {{passenger.paxList}}   -->
                  <!-- {{sHotelSearchObj}} -->
                  <!-- {{'pax '+JSON.stringify(paxObj[0].dob)}} -->
                  <div class="passenger-form-wrapper">
                    <div>
                      <div
                        :id="'scrollTo'+index"
                        :ref="'scrollTo'+index"
                        v-for="(pax,index) in passenger.paxList.slice(0,passenger.paxList.length-2)"
                        :key="'pax'+index"
                      >
                        <cPax
                          v-if="countryResponse!=null"
                          @caughtError="getErrorPax"
                          @getMblEmailFromRes="getEmailAndMblNo"
                          @getDob="getSelectedDob"
                          @getSelExpryDate="getSelectedExpryDate"
                          @getMblcode="getContactMblcode"
                          @getContactName="onAssFnameToContact"
                          @getIsDisable="toGetIsDisable"
                          :citizen="sHotelSearchObj?sHotelSearchObj.areaObj.cityName:null"
                          :paxIndex="index"
                          :pax="pax"
                          :rule="getRules(pax.paxType)"
                          :paxSubmit="paxSubmitted"
                        />
                      </div>

                      <cContact
                        v-if="passenger.paxList[passenger.paxList.length-2] && countryResponse!=null"
                        :contDetail="passenger.paxList[passenger.paxList.length-2]"
                        :rule="getRules(passenger.paxList[passenger.paxList.length-2].paxType)"
                      />
                      <CAlert v-if="valMsg!=null" show color="danger">{{valMsg}}</CAlert>
                      <CCard class="info-card">
                        <div class="form-title">
                          <h2>{{$t('passInfo.bookRef')}}</h2>
                        </div>
                        <CCardBody class="individual-info pt-25px border-none">
                          <div class="custom-input-pass">
                            <!-- :rules="'max:30'" -->
                            <ValidationProvider v-slot="{ errors }">
                              <input
                                v-if="passenger.paxList[passenger.paxList.length-1]"
                                placeholder="Enter agent reference here ( optional )"
                                class="form-control"
                                :maxlength="100"
                                v-model="passenger.paxList[passenger.paxList.length-1].bookingRef"
                              />
                              <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                              </div>
                            </ValidationProvider>
                          </div>
                        </CCardBody>
                      </CCard>

                      <!-- <cSelFlightInfo :isPaxPage="true"
                                                                                v-if="selFlight.ob.obFlight.length>0 || selFlight.ib.ibFlight.length>0"
                                                                                :selflightObj="selFlight"
                      />-->
                      <!-- <cPerPaxPriceInfo
                                                                                v-if="selFlight.ob.obFlight.length>0 || selFlight.ib.ibFlight.length>0"
                                                                                :selflightObj="selFlight"
                      />-->

                      <!-- Totalpriceinfo Component -->
                      <!-- <cTotalPriceInfo
                                                                                v-if="selFlight.ob.obFlight.length>0 || selFlight.ib.ibFlight.length>0"
                                                                                :selflightObj="selFlight"
                      />-->
                      <!--                                            <div class="tc-text">Lorem ipsum dolor sit amet, consectetur adipisicing-->
                      <!--                                                elit. Architecto,<a @click="onToggleFRModal">View Fare Rules</a>-->
                      <!--                                                eveniet.-->
                      <!--                                            </div>-->

                      <!-- {{invalid||toDisable}} -->
                      <button @click="paxSubmitted=true">Pay</button>
                      <cHotelFooter
                        v-if="sHotelSearchObj && (sHotelSearchObj.trip==2 || sHotelSearchObj.trip==1)"
                        :isSticky="false"
                        :isFlightSel="selFlight && selFlight.ob!=null|| selFlight && selFlight.ib!=null"
                        :tooltipText="(invalid||toDisable)?$t('passInfo.paxPageBtnTooltip'):null"
                        :buttonName="$t('passInfo.continue')"
                        :selFlight="selFlight"
                        :type="true"
                        @onContinue="paxSubmitted=true"
                      />

                      <cMLFlightFooter
                        v-if="sHotelSearchObj && sHotelSearchObj.trip==3"
                        :isSticky="false"
                        :isFlightSel="selFlight && selFlight.length!=0"
                        :buttonName="$t('passInfo.continue')"
                        :selFlight="selFlight"
                        :type="true"
                        @onContinue="paxSubmitted=true"
                      />
                      <!-- <CRow>
                                                                            <CCol class="primary-cta-btn">
                                                                                <CButton  type="submit" >
                                                                                    {{$t('passInfo.pay')}}
                                                                                </CButton>
                                                                            </CCol>
                      </CRow>-->
                    </div>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
          <div class="right mob-m-auto">
            <div class="search-modify-wrap booking-sum-right-stick">
              <div class="total-price-wrap">
                <!--                                               <div class="total-price-wrap"  :class="{'smooth441ani': isSummaryAnim}">-->
                <div class="title packages mt-0px mb-0">
                  <div class="main" style="margin-bottom: 11px;">{{$t('passInfo.bookingSummary')}}</div>
                  <span>
                    <img src="@imgPath/img/svg/icons/cross-radius.svg" alt width="20px" />
                  </span>
                </div>
                <div @click="isSummaryAnim =!isSummaryAnim">
                  <cPerPaxPriceInfo
                    v-if="sHotelSearchObj && (sHotelSearchObj.trip==2 || sHotelSearchObj.trip==1) &&
                       selFlight&&selFlight.ob"
                    :selflightObj="selFlight"
                  />

                  <!-- <div v-for="(selflightObj, index) in selFlight" :key="'p'+index"> -->
                  <cMLPerPaxPriceInfo
                    v-if="sHotelSearchObj && sHotelSearchObj.trip==3 &&
                       selFlight&&selFlight.length!=0"
                    :pricingUnit="selFlight"
                  />
                  <!-- </div> -->
                </div>
                <div class="total-wrap">
                  <cTotalPriceInfo
                    v-if="sHotelSearchObj && (sHotelSearchObj.trip==2 || sHotelSearchObj.trip==1)
                       && selFlight&&selFlight.ob
                       && selFlight.ob.clientPricing&&selFlight.ob.clientPricing.isTotal"
                    :isFooter="false"
                    :selflightObj="selFlight"
                  />

                  <cMLTotalPriceInfo
                    v-if="sHotelSearchObj && sHotelSearchObj.trip==3 && selFlight &&
                       selFlight.length!=0 && selFlight[0].clientPricing.isTotal"
                    :isFooter="false"
                    :lsPricingUnits="selFlight"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
// import cFareRule from "../../../../components/modal/cFareRule";
import cMLSelFlightInfo from "../../../../components/MLCity/pricing/cMLSelFlightInfo";
import cMLTotalPriceInfo from "../../../../components/MLCity/pricing/cMLTotalPriceInfo";
import cMLPerPaxPriceInfo from "../../../../components/MLCity/pricing/cMLPerPaxPriceInfo";
import cMLFlightFooter from "../../../../components/MLCity/footer/cMLFlightFooter";
import cSelFlightInfo from "../../../../components/result/cSelFlightInfo";
import cPerPaxPriceInfo from "../../../../components/result/cPerPaxPriceInfo";
import cTotalPriceInfo from "../../../../components/result/cTotalPriceInfo";
import BaseConfiguration from "../../../../config/base.js";
import { PAX, PAX_TITLE, TRIP } from "../../../../util/constants.js";
import cPax from "../../../../components/booking/hotel/pax/cPax";
import cContact from "../../../../components/booking/hotel/pax/cContact";
import { ValidationProvider } from "vee-validate";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../../util/apiValidate.js";
import { ValidationObserver, localize, Validator } from "vee-validate";
import {
  handleJWT,
  getErrorAlertValue,
  groupBy,
  cloneData,
  forceScrollToTop,
  addClassToBody,
  removeClassBody,
  handleSessionExist,
  cloneDeep
} from "../../../../util/util";
// import nb from "../../../../translations/validation/nb.json";
// import en from "../../../../translations/validation/en.json";
import { mapGetters, mapActions } from "vuex";
import router, {
  navigate,
  goBack,
  updateDataEdited
} from "../../../../router/index";
import apiGetCountryList from "../../../../services/apiGetCountryList.js";
import {
  COMPONENT_NAME,
  PATHNAME,
  ID_TYPE
} from "../../../../util/constants.js";
import Logger from "../../../../services/logger";
import apiCreateBooking from "../../../../services/apiCreateBooking.js";
import {
  subYears,
  isValidDob,
  withOutTime,
  isValidExpiryDate,
  formatDate,
  addMonths,
  subDays,
  addYears
} from "../../../../util/date/dateFunctions";
import cHotelFooter from "../../../../components/booking/hotel/result/cHotelFooter";
import cAlertModal from "./../../../../components/form/cAlertModal";

// localize({
//     en: {
//         messages: en.messages.PaxPage,
//     },
//     nb: {
//         messages: nb.messages.PaxPage
//     }
// });

export default {
  name: COMPONENT_NAME.PAXPAGE,
  components: {
    cContact,
    cPax,
    ValidationProvider,
    ValidationObserver,
    cSelFlightInfo,
    cPerPaxPriceInfo,
    cTotalPriceInfo,
    cHotelFooter,
    cAlertModal,
    cMLSelFlightInfo,
    cMLTotalPriceInfo,
    cMLPerPaxPriceInfo,
    cMLFlightFooter
  },
  data: () => ({
    sPricingRoomResult:{"sessionId":"834672ed-5abc-496e-8dba-bce249338bd8","hotelResult":{"amenities":[],"hotelId":"XKQPG140","name":"Demo Hotel 2","rooms":[{"supplierRef":{"RoomSearchRef":{"hotelId":"XKQPG140","supplierId":"AZ_amadeus_test"},"RoomPriceRef":{"offerId":"NCP68222QW"}},"supplierId":"AZ_amadeus_test","hotelId":"XKQPG140","hotelName":"Demo Hotel 2","roomID":"NCP68222QW","bedCount":1,"category":"","price":{"baseAmount":2450,"currency":"SGD","totalAmount":2450,"tax":0,"perNightPrice":350},"type":"","description":"Standard King Room","uniqId":"Room_SIN_XKQPG140_0_0","pricingInfo":{"isPriced":true,"error":[]}}],"location":{"address":{"cityCode":"QPG","cityName":"New York","countryCode":"US","lines":"1A Cuscaden Road","postalCode":"249716"},"contact":{"fax":"+65 63360911","phoneNumber":"+65 63360911"},"distance":{"info":""}},"desc":"The hotel is located in city center near major shopping centers.","requiredGuestInfo":{"contactInfo":{"isMandatory":true,"onlyForLeadGuest":true},"firstName":{"isMandatory":true},"lastName":{"isMandatory":true},"paxTitle":{"isMandatory":true}}}},

    // isFRModalshow: false,
    paxSubmitted: false,
    alertValue: null,
    isSummaryAnim: false,
    showBookFailAlert: false,
    valMsg: null,
    passenger: {
      validation: [],
      paxList: []
    },
    selDob: [],
    selExpryDate: [],
    sHotelSearchObj: null,
    selFlight: null,
    toDisable: false
    // isModifiedSearch:false
  }),

  mounted() {
    //this.$root.$emit("toggle-fixed-header", true);
    this.$root.$emit("toggle-sidebar-minimize");
  },

  async created() {
    //forceScrollToTop();
    this.$root.$emit("toggle-sidebar-minimize");
    let that = this;
    setTimeout(function() {
      that.scrollToElement("paxpage");
    }, 100);

    // if(this.sHotelSearchObj && this.sHotelSearchObj.trip!=TRIP.MULTI_CITY){
    this.sHotelSearchObj = this.GET_HOTEL_SEARCH_OBJ;
    // this.selFlight = this.sSelFlight;
    // }else{
    //  this.sHotelSearchObj = this.GET_ML_SEARCH_OBJ;
    //   this.selFlight = cloneDeep(this.sMLSelFlight);
    // }

    if (this.sHotelSearchObj != null) {
      this.passenger.validation = this.getDefaultValidation(
        this.sHotelSearchObj
      );
      this.SET_VALD_LIST(this.passenger.validation);

      this.passenger.paxList = this.getDefaultPaxList(this.sHotelSearchObj);
    } else {
      // navigate(PATHNAME.FLIGHTSEARCH); //need to handle
      // return;
    }
    let actualPaxList = this.passenger.paxList;

    if (this.paxObj != null) {
      //   console.log(JSON.parse(JSON.stringify(this.sSelDob)));
      this.getSelectedDob();
      this.getSelectedExpryDate();
      this.passenger.paxList = JSON.parse(JSON.stringify(this.paxObj));

      // console.log(JSON.parse(JSON.stringify(this.paxObj)));

      this.passenger.paxList = this.checkForPaxFromStore(
        actualPaxList,
        this.passenger.paxList
      );
      let paxlist = this.passenger.paxList;
      let spaxLs = [];
      for (let i = 0; i < this.passenger.paxList.length; i++) {
        if (
          this.passenger.paxList[i].fName != null &&
          this.passenger.paxList[i].fName
        ) {
          spaxLs.push(this.passenger.paxList[i]);
        } else if (this.passenger.paxList[i].paxType == "Contact") {
          spaxLs.push(this.passenger.paxList[i]);
        } else if (this.passenger.paxList[i].hasOwnProperty("bookingRef")) {
          spaxLs.push(this.passenger.paxList[i]);
        }
      }
      this.SET_PAX_LIST(spaxLs);

      if (paxlist.length != 0) {
        this.passenger.paxList = paxlist;
      }
    }
    let cntryRes;
    if (this.countryResponse == null) {
      cntryRes = await this.getCountryListRes();
    } else {
      cntryRes = this.countryResponse;
    }

    updateDataEdited(true);
    // }
  },

  computed: {
    ...mapGetters("sCMultiCitySearch", {
      GET_ML_SEARCH_OBJ: "GET_ML_SEARCH_OBJ"
    }),
    ...mapGetters("sMLResult", {
      sMLSelFlight: "GET_SEL_FLI_FRM_PRIC"
    }),
    ...mapGetters("sHotelSearch", {
      GET_HOTEL_SEARCH_OBJ: "GET_HOTEL_SEARCH_OBJ"
    }),
    ...mapGetters("sGuestPage", {
      paxObj: "GET_PAX_LIST",
      svaldLs: "GET_VALD_LIST",
      sSelDob: "GET_SEL_DOB",
      sExpryDate: "GET_SEL_EXPRY_DATE"
    }),
    ...mapGetters("language", {
      lang: "GET_LANGUAGE"
    }),
    ...mapGetters("sCountryList", {
      countryResponse: "GET_COUNTRY_RES"
      // countryCode: "GET_COUNTRY_CODE"
    }),
    ...mapGetters("sHotelRoomResult", {
      // sPricingRoomResult: "GET_PRICING_ROOM_RESULT",
      //     sSelFlight: "GET_SEL_FLI_FRM_PRIC",
      //    searchPricingReq:'GET_SEARCH_PRICING_REQ',
    })
  },
  methods: {
    ...mapActions("sGuestPage", {
      SET_CREATE_BOOKING_REQ: "SET_CREATE_BOOKING_REQ",
      SET_CREATE_BOOKING_RES: "SET_CREATE_BOOKING_RES",
      SET_PAX_LIST: "SET_PAX_LIST",
      SET_VALD_LIST: "SET_VALD_LIST",
      SET_SEL_DOB: "SET_SEL_DOB",
      SET_EXPRY_DATE: "SET_EXPRY_DATE"
    }),

    ...mapActions("sCountryList", ["SET_COUNTRY_REQ"]),
    ...mapActions("sCountryList", ["SET_COUNTRY_RES"]),

    // modifiedSearch(pIsModified) {
    //     this.isModifiedSearch=pIsModified;
    // },
    // onToggleFRModal() {
    //     try {
    //         if (BaseConfiguration.isDebug) console.log("onToggleFRModal");
    //         this.isFRModalshow = !this.isFRModalshow;

    //     } catch (err) {
    //         let body = Logger.buildRequest(
    //             COMPONENT_NAME.PAXPAGE,
    //             "error in onToggleFRModal",
    //             err.toString(),
    //             "onToggleFRModal",
    //             LOG_TYPE.ERROR
    //         );
    //         Logger.getResponse(body);
    //     }

    // },

    getErrorPax(pPaxIndex) {
      this.scrollToElement("scrollTo" + pPaxIndex);
    },

    ///scroll into view
    scrollToElement(pRef) {
      var el = null;
      if (pRef == "paxpage") {
        el = this.$refs.paxpage;
      } else {
        for (var i in this.$refs) {
          if (i == pRef) {
            el = this.$refs[i];
            break;
          }
        }
      }
      if (el) {
        if (el[0]) {
          el[0].scrollIntoView({ behavior: "smooth" });
        } else {
          el.scrollIntoView(); //{ behavior: 'smooth' }
        }
      }
    },

    // paxError(pPaxIndex){
    //     alert(pPaxIndex)
    // },

    toGetIsDisable(pisDisable) {
      this.toDisable = pisDisable;
    },
    /// to check if there is any pax details from  store
    checkForPaxFromStore(pactualPaxList, psPaxList) {
      let retValue = [];
      let contObj = psPaxList.length - 2;
      let b = true;
      try {
        if (BaseConfiguration.isDebug) console.log("checkForPaxFromStore");
        for (let k = 0; k < psPaxList.length - 2; k++) {
          psPaxList[k]["checked"] = false;
          if (this.sExpryDate != null && this.sExpryDate.length != 0) {
            psPaxList[k].expiryDate = this.sExpryDate[k];
          }
          if (this.sSelDob != null && this.sSelDob.length != 0) {
            psPaxList[k].dob = this.sSelDob[k];
          }
        }
        for (let j = 0; j < pactualPaxList.length - 2; j++) {
          b = true;
          for (let i = 0; i < psPaxList.length - 2; i++) {
            if (psPaxList[i].paxType != "Contact" || psPaxList[i].paxType) {
              if (psPaxList[i].checked != true) {
                if (pactualPaxList[j].paxType == psPaxList[i].paxType) {
                  retValue.push(psPaxList[i]);
                  psPaxList[i].checked = true;
                  b = false;
                  break;
                } else {
                  break;
                }
              }
            }
          }
          if (b == true) {
            retValue.push(pactualPaxList[j]);
          }
        }

        for (let index = 0; index < psPaxList.length; index++) {
          if (index > contObj - 1) {
            retValue.push(psPaxList[index]);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in checkForPaxFromStore",
          err.toString(),
          "checkForPaxFromStore",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getSelectedDob(pSelDob, pPaxIndex) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelectedDob");
        if (pSelDob) {
          ///to assign the dob to respective pax if there is any dob in store
          //   if(this.sSelDob!=null && this.sSelDob.length!=0) {

          //     for (let i = 0; i < this.sSelDob.length; i++) {
          //     //    if(this.sSelDob[i]!=null && i!=pPaxIndex) {
          //     //        this.selDob[i]=this.sSelDob[i];
          //     //    }
          //     //    else{
          //            ///to assign the dob to newly added pax
          //            if(this.sSelDob[pPaxIndex]!=null || this.sSelDob[pPaxIndex]!=undefined) {

          //                for (let index = pPaxIndex; index < this.sSelDob.length; index++) {
          //                this.selDob[index+1]=this.sSelDob[index];

          //             }
          //             this.selDob[pPaxIndex]=pSelDob;
          //            }else{
          //             this.selDob[pPaxIndex]=pSelDob;
          //            }
          //            break;
          //         // }
          //     }
          //     ///to assign the dob to newly added pax
          //     if(pPaxIndex>this.selDob.length-1) {
          //         this.selDob[pPaxIndex]=pSelDob;
          //     }

          //   }
          if (
            this.selDob[pPaxIndex] != null ||
            this.selDob[pPaxIndex] != undefined
          ) {
            this.selDob.splice(pPaxIndex, 0, pSelDob);
          } else {
            this.selDob[pPaxIndex] = pSelDob;
          }
        }
        if (pSelDob == null && pPaxIndex != null) {
          this.selDob[pPaxIndex] = pSelDob;
        }
        ///to assign the dob to the already available pax from store
        else if (!pSelDob && pPaxIndex == null) {
          if (this.sSelDob != null && this.sSelDob.length != 0) {
            for (let i = 0; i < this.sSelDob.length; i++) {
              if (this.sSelDob[i] != null) {
                this.selDob[i] = this.sSelDob[i];
              }
            }
          }
        }
        this.toDisable = false;
        //  console.log(JSON.stringify(this.selDob))
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in getSelectedDob",
          err.toString(),
          "getSelectedDob",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getSelectedExpryDate(pSelExpryDob, pPaxIndex) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelectedExpryDate");
        if (pSelExpryDob) {
          ///to assign the expiry date to respective pax if there is any expirydate in store
          // if(this.sExpryDate!=null && this.sExpryDate.length!=0) {
          //     for (let i = 0; i < this.sExpryDate.length; i++) {
          //        if(this.sExpryDate[i]!=null && i!=pPaxIndex) {
          //            this.selExpryDate[i]=this.sExpryDate[i];
          //        }
          //        else{
          //            /// to check if the newly added pax is in between , if so assign the expiry to the actual pax
          //            if(this.sExpryDate[pPaxIndex]!=null || this.sExpryDate[pPaxIndex]!=undefined) {
          //                for (let index = pPaxIndex; index < this.sExpryDate.length; index++) {
          //                this.selExpryDate[index+1]=this.sExpryDate[index];

          //             }
          //             ///to assign the expiry date to newly added pax
          //             this.selExpryDate[pPaxIndex]=pSelExpryDob;
          //            }else{
          //            this.selExpryDate[pPaxIndex]=pSelExpryDob;
          //                }
          //            break;
          //         }

          //     }
          //     ///to assign the dob to newly added pax
          //     if(pPaxIndex>this.sExpryDate.length-1) {
          //         this.selExpryDate[pPaxIndex]=pSelExpryDob;
          //     }
          //   }
          //    else{
          //        ///to assign the dob to newly added pax
          //       this.selExpryDate[pPaxIndex]=pSelExpryDob;
          // }
          if (
            this.selExpryDate[pPaxIndex] != null ||
            this.selExpryDate[pPaxIndex] != undefined
          ) {
            this.selExpryDate.splice(pPaxIndex, 0, pSelExpryDob);
          } else {
            this.selExpryDate[pPaxIndex] = pSelExpryDob;
          }
        }
        if (pSelExpryDob == null && pPaxIndex != null) {
          this.selExpryDate[pPaxIndex] = pSelExpryDob;
        }
        ///to assign the dob to the already available pax from store
        else if (
          !pSelExpryDob &&
          pPaxIndex == null &&
          this.sExpryDate != null &&
          this.sExpryDate.length != 0
        ) {
          //  if(this.sExpryDate!=null && this.sExpryDate.length!=0) {
          for (let i = 0; i < this.sExpryDate.length; i++) {
            if (this.sExpryDate[i] != null) {
              this.selExpryDate[i] = this.sExpryDate[i];
            }
          }
        } else if (
          pSelExpryDob == null &&
          pPaxIndex != null &&
          pPaxIndex != undefined
        ) {
          this.selExpryDate[pPaxIndex] = pSelExpryDob;
        }
        this.toDisable = false;
        //  console.log(JSON.stringify(this.selDob))
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in getSelectedExpryDate",
          err.toString(),
          "getSelectedExpryDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getCountryListRes() {
      // this.countrySel=true;
      let retValue;
      try {
        //let langCode = get lang code
        let countryLsRequest = apiGetCountryList.buildRequest(this.lang);
        if (countryLsRequest) {
          this.SET_COUNTRY_REQ(countryLsRequest); //save req in store

          let countryLsResponse = await apiGetCountryList.getResponse(
            countryLsRequest
          );
          //  let countryLsResponse= {data:{"status":"Error","error":[{"code":"SES03","value":"session not exist\r\n"}]}}

          // alert(JSON.stringify(countryLsResponse))
          if (
            VALIDATE_SUCCESS_RES(countryLsResponse) &&
            countryLsResponse.data.data.length > 0
          ) {
            this.SET_COUNTRY_RES(countryLsResponse.data.data); //save res in store
            retValue = countryLsResponse.data.data;
            // console.log(countryLsResponse.data.data);
          } else {
            this.showAlert = true;
            let error = getErrorMessage(countryLsResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              // let isSessionExpired= handleSessionExist(countryLsResponse.data);
              let isSessionExpired;
              if (countryLsResponse) {
                isSessionExpired = handleSessionExist(countryLsResponse.data);
              }
              if (!isSessionExpired) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid country request"; //
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.API_GET_COUNTRY_LIST,
          "error in getting response from GetCounryList API",
          err.toString(),
          "getCountryListRes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getEmailAndMblNo(pemail, pmblNo) {
      try {
        this.toDisable = false;
        this.passenger.paxList[
          this.passenger.paxList.length - 2
        ].email = pemail;
        this.passenger.paxList[
          this.passenger.paxList.length - 2
        ].mobileNo = pmblNo;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in getEmailAndMblNo",
          err.toString(),
          "getEmailAndMblNo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getContactMblcode(pmblCodeObj) {
      try {
        this.passenger.paxList[
          this.passenger.paxList.length - 2
        ].mobileCodeObj = pmblCodeObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in getContactMblcode",
          err.toString(),
          "getContactMblcode",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onAssFnameToContact(pFName) {
      try {
        if (BaseConfiguration.isDebug) console.log("onAssFnameToContact");
        if (this.passenger && this.passenger.paxList) {
          for (let index = 0; index < this.passenger.paxList.length; index++) {
            const pax = this.passenger.paxList[index];
            if (pax.fName) {
              pax.fName = pax.fName.toUpperCase();
            }
            if (pax.lName) {
              pax.lName = pax.lName.toUpperCase();
            }
          }
        }
        if (this.passenger.paxList[this.passenger.paxList.length - 2].cName) {
          this.passenger.paxList[
            this.passenger.paxList.length - 2
          ].cName = this.passenger.paxList[
            this.passenger.paxList.length - 2
          ].cName;
        } else {
          if (this.passenger && this.passenger.paxList) {
            this.passenger.paxList[
              this.passenger.paxList.length - 2
            ].cName = this.passenger.paxList[0].fName;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in onAssFnameToContact",
          err.toString(),
          "onAssFnameToContact",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getDefaultValidation(pTravelSearch) {
      let valList = [];
      //    if(this.sPricingRoomResult && this.sPricingRoomResult.data &&
      //                 this.sPricingRoomResult.data.data &&
      //                 this.sPricingRoomResult.data.data.paxTypes) {
      //     for(var i in this.sPricingRoomResult.data.data.paxTitles) {
      //         if(i=="ADT"){
      //              PAX.ADULT=i;
      //         }else if(i=="CHD"){
      //             PAX.CHILDREN=i;
      //         }else if(i=="INF"){
      //             PAX.INFANT=i;
      //         }
      //     }
      //   }
      let valObj = {
        paxType: PAX.ADULT,
        fNameCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },
        fNameRules: {
          required: true,
          min: 0,
          max: 50,
          // max: 50,
          // regex: "^[a-zA-Z_ ]+$"
          //regex: "^[\S]+$",
          noSpaceinInitial: true,
          noNumbers: true
        },
        lNameCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },

        lNameRules: {
          required: true,
          min: 0,
          max: 50,
          // regex: "^[a-zA-Z_ \S]+$"
          //regex: "^[\S.*]+$"
          noSpaceinInitial: true,
          noNumbers: true
        },
        genderCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },
        genderRules: {
          required: true
          // min: 0,
          // max: 0,
          //regex: null
        },
        dobCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },
        dobMandateRule: {
          required: true
        },
        depDobRules: {
          depMin: subYears(
            pTravelSearch.date.checkInDate,
            BaseConfiguration.dobValidation.adultMin
          ),
          depMax: subYears(
            pTravelSearch.date.checkInDate,
            BaseConfiguration.dobValidation.adultMax
          )
        },
        // arrDobRules: {
        //    arrMin: subYears(
        //         pTravelSearch.route[1]?pTravelSearch.route[1].date: pTravelSearch.date.checkInDate,
        //         BaseConfiguration.dobValidation.adultMin
        //     ),
        //     arrMax: subYears(
        //         pTravelSearch.route[1]?pTravelSearch.route[1].date: pTravelSearch.date.checkInDate,
        //         BaseConfiguration.dobValidation.adultMax
        //     ),
        //  },
        idNoCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },
        idNoRules: {
          required: true,
          min: 0,
          max: 0,
          regex: [
            {
              pp: {
                required: true,
                min: null,
                max: 10,
                regex: "^[a-zA-Z0-9]+$"
              },
              nric: {
                required: true,
                min: null,
                // max: null,
                regex:
                  "^((([1-9])|([1][0-4])|([0][1-9]))[/](([A-Z]){1,7}[(][N][A][I][N][G][)]|([A-Z]){2,11}[(][N][)])[0-9]{5,6})$"
              }
            }
          ]
        },
        expryDateCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },
        expryDateMandatoryRule: {
          required: true
        },
        expryDateRules: {
          min: new Date(),
          max: addMonths(
            pTravelSearch.date.checkInDate,
            BaseConfiguration.ppExpiryDate
          )
          //regex: null
        },
        idTypeCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },
        idTypeRules: {
          required: true
          // min: 1,
          // max: 22,
          // regex: "[0-9]{2}[/][a-zA-Z]{6}[(][a-zA-Z]{5}[)][0-9]{5,6}"
        },
        nationalityCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },
        nationalityRules: {
          required: true
          // min: 0,
          // max: 0,
          // regex: null
        },
        paxTitleCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },
        paxTitleRules: {
          required: true
          // regex: null
        }
      };

      let contactVal = {
        paxType: PAX.CONTACT,
        cNameCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },
        cNameRules: {
          required: true,
          min: 0,
          max: 50,
          paxregex: "^[a-zA-Z_ ]+$"
        },
        emailCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },
        emailRules: {
          required: true,
          email: "email"
        },
        mobileNoCtrl: {
          isDisable: false,
          isVisible: true,
          isMandatory: true
        },
        mobileNoRules: {
          required: true,
          min: 0,
          max: 15,
          paxregex: "^[0-9]*$"
        }
      };
      try {
        ///Adult
        let adtCloneObj = JSON.parse(JSON.stringify(valObj));
        let adultValObj = this.assignRulesFrmRes(
          adtCloneObj,
          this.sPricingRoomResult,
          PAX.ADULT
        );
        // let retValObj = cloneData(pValObj);

        valList.push(adultValObj);

        ///Child
        let chdCloneObj = JSON.parse(JSON.stringify(valObj));

        let childValObj = this.assignRulesFrmRes(
          chdCloneObj,
          this.sPricingRoomResult,
          PAX.CHILDREN
        );
        childValObj.paxType = PAX.CHILDREN;

        (childValObj.depDobRules.depMin = subYears(
          pTravelSearch.date.checkOutDate,
          BaseConfiguration.dobValidation.childMin
        )),
          (childValObj.depDobRules.depMax = subYears(
            pTravelSearch.date.checkOutDate,
            BaseConfiguration.dobValidation.childMax
          )),
          // childValObj.arrDobRules.arrMin= subYears(
          //     pTravelSearch.route[1]?pTravelSearch.route[1].date: pTravelSearch.date.checkInDate,
          //     BaseConfiguration.dobValidation.childMin
          // ),
          // childValObj.arrDobRules.arrMax= subYears(
          //     pTravelSearch.route[1]?pTravelSearch.route[1].date: pTravelSearch.date.checkInDate,
          //     BaseConfiguration.dobValidation.childMax
          // ),
          // childValObj.dobRules.regex= null
          valList.push(childValObj);

        ///Infant
        let inftCloneObj = JSON.parse(JSON.stringify(valObj));

        let infantValObj = this.assignRulesFrmRes(
          inftCloneObj,
          this.sPricingRoomResult,
          PAX.INFANT
        );
        infantValObj.paxType = PAX.INFANT;

        (infantValObj.depDobRules.depMin = subYears(
          pTravelSearch.date.checkOutDate,
          BaseConfiguration.dobValidation.infantMin
        )),
          (infantValObj.depDobRules.depMax = subDays(
            pTravelSearch.date.checkOutDate,
            BaseConfiguration.dobValidation.infantMax
          )),
          //  infantValObj.arrDobRules.arrMin= subYears(
          //     pTravelSearch.route[1]?pTravelSearch.route[1].date: pTravelSearch.date.checkInDate,
          //     BaseConfiguration.dobValidation.infantMin
          // ),
          //  infantValObj.arrDobRules.arrMax= subDays(
          //     pTravelSearch.route[1]?pTravelSearch.route[1].date: pTravelSearch.date.checkInDate,
          //     BaseConfiguration.dobValidation.infantMax
          // ),
          // infantValObj.dobRules.regex= null
          valList.push(infantValObj);

        let retContactVal = this.assignContactVal(
          contactVal,
          this.sPricingRoomResult
        );
        ///Contact(Adult)
        valList.push(retContactVal);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in getDefaultValidation",
          err.toString(),
          "getDefaultValidation",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return valList;
    },

    ///to assign required contact info to contact validation object
    assignContactVal(pContactVal, pSelectedPricing) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignContanctVal");
        let retContactVal = pContactVal;
        let contactInfo = null;
        if (
          pSelectedPricing &&
          pSelectedPricing.hotelResult &&
         pSelectedPricing.hotelResult.requiredGuestInfo
        ) {
          contactInfo =
           pSelectedPricing.hotelResult.requiredGuestInfo
              .contactInfo;
        }

        if (contactInfo) {
          if (contactInfo.hasOwnProperty("isMandatory")) {
            retContactVal.cNameCtrl.isMandatory = contactInfo.isMandatory;
            retContactVal.cNameCtrl.onlyForLeadGuest =
              contactInfo.onlyForLeadGuest;
          }
          if (contactInfo.hasOwnProperty("onlyForLeadGuest")) {
            retContactVal.cNameCtrl.onlyForLeadGuest =
              contactInfo.onlyForLeadGuest;
          }
        }

        return retContactVal;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in assignContanctVal",
          err.toString(),
          "assignContanctVal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to assign requiredGuestInfo to validation object
    assignRulesFrmRes(pValObj, pSelectedPricing, pPaxType) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignRulesFrmRes");
        let retValObj = pValObj;
        let pax = null;
        if (pSelectedPricing) {
          if (
            pSelectedPricing.hotelResult &&
            pSelectedPricing.hotelResult.requiredGuestInfo
          ) {
            pax =pSelectedPricing.hotelResult.requiredGuestInfo;
          }
        }
        // if (
        //   pSelectedPricing.data &&
        //   pSelectedPricing.data.data &&
        //   pSelectedPricing.data.data.paxTitle
        // ) {
        //   // if (pPaxType == PAX.ADULT) {
        //   //     PAX_TITLE.ADT=pSelectedPricing.data.data.paxTitle.adult;
        //   // } else if (pPaxType == PAX.CHILDREN) {
        //   //     PAX_TITLE.CHD=pSelectedPricing.data.data.paxTitle.Child;
        //   // } else if (pPaxType == PAX.INFANT) {
        //   //     PAX_TITLE.INF=pSelectedPricing.data.data.paxTitle.Infant;
        //   // }
        // }

        ///fname

        if (pax && pax.firstName) {
          if (pax.firstName.hasOwnProperty("isMandatory")) {
            retValObj.fNameCtrl.isMandatory = pax.firstName.isMandatory;
          }
          retValObj.fNameRules.required = retValObj.fNameCtrl.isMandatory;
          // if (pax.firstName.min) {
          //     retValObj.firstName.min = pax.firstName.min;
          // }
          // if (pax.firstName.max) {
          //     retValObj.firstName.max =pax.firstName.max;
          // }
          retValObj.fNameCtrl.isVisible = true; ///Visibility
        } else {
          // retValObj.fNameCtrl.isVisible = false;
        }

        ///lname

        if (pax && pax.lastName) {
          if (pax.lastName.hasOwnProperty("isMandatory")) {
            retValObj.lNameCtrl.isMandatory = pax.lastName.isMandatory;
          }

          retValObj.lNameRules.required = retValObj.lNameCtrl.isMandatory;
          // if (pax.lNameRules.min) {
          //     retValObj.lNameRules.min = pax.lNameRules.min;
          // }
          // if (pax.lNameRules.max) {
          //     retValObj.lNameRules.max = pax.lNameRules.max;
          // }
          retValObj.lNameCtrl.isVisible = true; ///Visibility
        } else {
          retValObj.lNameCtrl.isVisible = false;
        }

        ///dob
        // if (pax && pax.dob) {
        //     if (pax.dob.hasOwnProperty('isMandatory')) {
        //         retValObj.dobCtrl.isMandatory = pax.dob.isMandatory;
        //     }
        //     retValObj.dobMandateRule.required = retValObj.dobCtrl.isMandatory;
        //     retValObj.dobCtrl.isVisible = true; ///Visibility
        // } else {
        //     retValObj.dobCtrl.isVisible = false;
        // }

        ///nationality
        // if (pax && pax.nationality) {
        //     if (pax.nationality.hasOwnProperty('isMandatory')) {
        //         retValObj.nationalityCtrl.isMandatory = pax.nationality.isMandatory;
        //     }
        //     retValObj.nationalityRules.required =
        //         retValObj.nationalityCtrl.isMandatory;
        //     retValObj.nationalityCtrl.isVisible = true; ///Visibility
        // } else {
        //     retValObj.nationalityCtrl.isVisible = false;
        // }

        ///docType(idType)
        // if (pax && pax.docType) {
        //     if (pax.docType.hasOwnProperty('isMandatory')) {
        //     //    if(pPaxType == PAX.ADULT){
        //         retValObj.idTypeCtrl.isMandatory = pax.docType.isMandatory;
        //         // }else{
        //         //    retValObj.idTypeCtrl.isMandatory = false;
        //         // }
        // }
        //     retValObj.idTypeRules.required = retValObj.idTypeCtrl.isMandatory;
        //     ///(idno is based on idtype)
        //     retValObj.idNoCtrl.isMandatory = retValObj.idTypeCtrl.isMandatory;
        //     retValObj.idNoRules.required = retValObj.idNoCtrl.isMandatory;
        //     retValObj.expryDateMandatoryRule.required = retValObj.idNoCtrl.isMandatory;
        //     retValObj.idTypeCtrl.isVisible = true;
        //     retValObj.idNoCtrl.isVisible = true; ///Visibility
        // } else {
        //     retValObj.idTypeCtrl.isVisible = false;
        //     retValObj.idNoCtrl.isVisible = false;
        // }

        // ///gender
        // if (pax && pax.genderRules) {
        //     if (pax.genderRules.hasOwnProperty('isMandatory')) {
        //         retValObj.genderCtrl.isMandatory = pax.genderRules.isMandatory;
        //     }
        //     retValObj.genderRules.required = retValObj.genderCtrl.isMandatory;
        //     if (pax.genderRules.min) {
        //         retValObj.genderRules.min = pax.genderRules.min;
        //     }
        //     if (pax.genderRules.max) {
        //         retValObj.genderRules.max = pax.lNameRules.max;
        //     }
        //     retValObj.genderCtrl.isVisible = true; ///Visibility
        // } else {
        //     retValObj.genderCtrl.isVisible = true; ///temp
        // }
        ///title

        if (pax && pax.paxTitle) {
          if (pax.paxTitle.hasOwnProperty("isMandatory")) {
            retValObj.paxTitleCtrl.isMandatory = pax.paxTitle.isMandatory;
          }
          retValObj.paxTitleRules.required = retValObj.paxTitleCtrl.isMandatory;
          retValObj.paxTitleCtrl.isVisible = true; ///Visibility
        } else {
          retValObj.paxTitleCtrl.isVisible = false;
        }

        return retValObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in assignRulesFrmRes",
          err.toString(),
          "assignRulesFrmRes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getDefaultExpiryDate() {
      let expryDate = addYears(new Date(), 1);
      expryDate = expryDate.toISOString();
      return expryDate;
    },

    getDefaultDob(pax) {
      let dob;

      if (pax && pax.paxType) {
        if (pax.paxType == PAX.ADULT) {
          dob = subYears(new Date(), 40);
        }
        if (pax.paxType == PAX.CHILDREN) {
          dob = subYears(new Date(), 12);
        }
        if (pax.paxType == PAX.INFANT) {
          dob = subYears(new Date(), 2);
        }
      }
      dob = dob.toISOString();
      return dob;
    },

    getDefaultPaxList(pHotelSearchObj) {
      let paxList = [];

      let paxObj = {
        paxType: PAX.ADULT,
        isLeadPax: false,
        isSameName: false,
        isSameId: false,
        fName: null,
        lName: null,
        gender: null,
        dob: null,
        validDob: null,
        idType: {
          code: null,
          name: null
        },
        expiryDate: null,
        validExpDate: null,
        expiryDate: this.getDefaultExpiryDate(),
        idNo: null,
        nationality: {
          countrycode: null,
          value: null,
          calling_code: null
        },
        paxTitle: {
          name: null,
          code: null
        }
      };

      let ContObj = {
        paxType: PAX.CONTACT,
        cName: null,
        email: null,
        mobileCodeObj: {
          countrycode: null,
          value: null,
          calling_code: null
        },
        mobileNo: null
      };

      let bookRefObj = {
        bookingRef: null
      };

      try {
        for (let g = 0; g < pHotelSearchObj.guestList.length; g++) {
          for (let i = 0; i < pHotelSearchObj.guestList[g].adult; i++) {
            var Pax = cloneData(paxObj);
            Pax.dob = this.getDefaultDob(Pax);
            Pax.displayPaxNum = i + 1;
            Pax.displayRoomNum = g + 1;

            paxList.push(Pax);
          }

          for (let i = 0; i < pHotelSearchObj.guestList[g].child; i++) {
            var Pax = cloneData(paxObj);
            Pax.paxType = PAX.CHILDREN;
            Pax.dob = this.getDefaultDob(Pax);
            Pax.displayPaxNum = i + 1;
            Pax.displayRoomNum = g + 1;
            paxList.push(Pax);
          }
          for (let i = 0; i < pHotelSearchObj.guestList[g].infant; i++) {
            var Pax = cloneData(paxObj);
            Pax.paxType = PAX.INFANT;
            Pax.dob = this.getDefaultDob(Pax);
            Pax.displayPaxNum = i + 1;
            Pax.displayRoomNum = g + 1;
            paxList.push(Pax);
          }
        }

        paxList.push(ContObj);
        paxList.push(bookRefObj);
      } catch (err) {
        let body = Logger.buildRequest(
          "getDefaultPaxList",
          "error in getDefaultPaxList",
          err.toString(),
          "getDefaultPaxList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return paxList;
    },

    dobValidate(pPaxType, pSelDate, pFName) {
      let retValue;
      let paxType =
        pPaxType == PAX.ADULT
          ? this.$t("passInfo.adult")
          : pPaxType == PAX.CHILDREN
          ? this.$t("passInfo.child")
          : this.$t("passInfo.infant");
      let nextPaxType =
        pPaxType == PAX.ADULT
          ? this.$t("passInfo.adult")
          : pPaxType == PAX.CHILDREN
          ? this.$t("passInfo.adult")
          : this.$t("passInfo.child");
      let paxAge =
        pPaxType == PAX.ADULT
          ? BaseConfiguration.dobValidation.adultMin
          : pPaxType == PAX.CHILDREN
          ? BaseConfiguration.dobValidation.childMin
          : BaseConfiguration.dobValidation.infantMin;
      try {
        if (pSelDate != null) {
          let depMin = withOutTime(
            new Date(this.getRules(pPaxType).depDobRules.depMin)
          );
          let depMax = withOutTime(
            new Date(this.getRules(pPaxType).depDobRules.depMax)
          );
          // let arrMin = withOutTime(new Date(this.getRules(pPaxType).arrDobRules.arrMin));
          // let arrMax = withOutTime(new Date(this.getRules(pPaxType).arrDobRules.arrMax));
          let selDate = withOutTime(new Date(pSelDate));
          if (isValidDob(depMin, depMax, selDate)) {
            // if(isValidDob(arrMin,arrMax,selDate))
            //             {
            //                 retValue = true;
            //             }
            //             else
            //             {
            //                  retValue = false;
            //                  this.valMsg = this.$t('passInfo.depDobInvalid')
            //     }
          } else {
            retValue = false;
            // this.valMsg = this.$t('passInfo.depDobInvalid')
          }
        } else {
          retValue = true;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          dobValidate,
          "error in dobValidate",
          err.toString(),
          "dobValidate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    isValidPaxObj(pPaxList) {
      let retValue = false;
      try {
        if (BaseConfiguration.isDebug) console.log("isValidPaxObj");
        if (this.passenger && pPaxList) {
          for (let i = 0; i < pPaxList.length - 2; i++) {
            if (
              pPaxList[i].validDob != null ||
              (pPaxList[i].idType.code != ID_TYPE.NRIC &&
                pPaxList[i].validExpDate != null)
            ) {
              retValue = false;
              break;
            } else {
              retValue = true;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in isValidPaxObj",
          err.toString(),
          "isValidPaxObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toGetPaxNameComparision(pList, isFname) {
      let retValue;
      var fnameCounts;
      var lnameCounts;
      var fNameDups;
      var lNameDups;
      try {
        if (BaseConfiguration.isDebug) console.log("toGetPaxNameComparision");
        ///count of fname (TEST - 1, JOHN -2 ---> i.e., there are 2 JOHN in fname)
        fnameCounts = _.countBy(pList, "fName");

        ///getting the pax details which has same fname
        fNameDups = _.filter(pList, x => fnameCounts[x.fName] > 1);
        ///count of lname from the pax which has same fname(TEST - 1, JOHN -2 ---> i.e., there are 2 JOHN in fname)
        lnameCounts = _.countBy(fNameDups, "lName");

        if (fNameDups.length != 0) {
          lNameDups = _.filter(fNameDups, x => lnameCounts[x.lName] > 1);
          if (lNameDups.length != 0) {
            for (let index = 0; index < lNameDups.length; index++) {
              lNameDups[index].isSameName = true;
            }
            this.scrollToElement("scrollTo" + lNameDups[0].paxIndex);
            retValue = false;
          } else {
            retValue = true;
          }
        } else {
          retValue = true;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in toGetPaxNameComparision",
          err.toString(),
          "toGetPaxNameComparision",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toComparePaxNames(pPaxList) {
      let retValue;

      try {
        if (BaseConfiguration.isDebug) console.log("toComparePaxNames");
        let mrPax = [],
          mrsPax = [],
          missPax = [],
          mstrPax = [];
        ///to group th pax based on their pax titles
        for (let i = 0; i < pPaxList.length - 2; i++) {
          pPaxList[i]["paxIndex"] = i;
          if (pPaxList[i].paxTitle.code == "Mr") {
            mrPax.push(pPaxList[i]);
          } else if (pPaxList[i].paxTitle.code == "Mrs") {
            mrsPax.push(pPaxList[i]);
          } else if (pPaxList[i].paxTitle.code == "Miss") {
            missPax.push(pPaxList[i]);
          } else if (pPaxList[i].paxTitle.code == "Master") {
            mstrPax.push(pPaxList[i]);
          }
        }
        let noMrDups, noMissDups, noMrsDups, noMstrDups;
        ///to check for duplicate names
        noMrDups = this.toGetPaxNameComparision(mrPax, true);
        if (noMrDups == true) {
          noMissDups = this.toGetPaxNameComparision(missPax, true);
          if (noMissDups == true) {
            noMrsDups = this.toGetPaxNameComparision(mrsPax, true);
            if (noMrsDups == true) {
              noMstrDups = this.toGetPaxNameComparision(mstrPax, true);
              if (noMstrDups == true) {
                retValue = true;
              } else {
                retValue = false;
              }
            } else {
              retValue = false;
            }
          } else {
            retValue = false;
          }
        } else {
          retValue = false;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in toComparePaxNames",
          err.toString(),
          "toComparePaxNames",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toComparePaxIDNo(pPaxList) {
      let retValue;
      let pList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("toComparePaxIDNo");
        let idCounts, idDups;
        for (let i = 0; i < pPaxList.length - 2; i++) {
          pPaxList[i]["paxIndex"] = i;
          if (
            pPaxList[i].idNo != "" &&
            pPaxList[i].idNo != null &&
            pPaxList[i].idNo != "null"
          ) {
            pList.push(pPaxList[i]);
          }
        }
        idCounts = _.countBy(pList, "idNo");

        idDups = _.filter(pList, x => idCounts[x.idNo] > 1);

        if (idDups.length != 0) {
          for (let j = 0; j < idDups.length; j++) {
            idDups[j].isSameId = true;
          }
          this.scrollToElement("scrollTo" + idDups[0].paxIndex);

          retValue = false;
        } else {
          retValue = true;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in toComparePaxIDNo",
          err.toString(),
          "toComparePaxIDNo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toCheckPaxDob(pdob, pPaxList) {
      let retValue = true;
      let selDobLs;
      let selExpryDate;
      try {
        if (BaseConfiguration.isDebug) console.log("toCheckPaxDob");

        if (this.sSelDob != null) {
          selDobLs = this.sSelDob;
        }

        if (pdob.length != 0 && pPaxList.length != 0) {
          for (let i = 0; i < pdob.length; i++) {
            for (let j = 0; j < pPaxList.length - 2; j++) {
              if (retValue == true) {
                pPaxList[j].fName = pPaxList[j].fName.toUpperCase();
                pPaxList[j].lName = pPaxList[j].lName.toUpperCase();
                if (selDobLs[j] != undefined) {
                  pPaxList[j].dob = selDobLs[j];
                  this.dobValidate(
                    pPaxList[j].paxType,
                    pPaxList[j].dob,
                    pPaxList[j].fName
                  );
                } else {
                  pPaxList[j].dob = null;
                }

                //  if(this.paxObj!=null && this.paxObj[j].dob!=null) {
                //     pPaxList[j].dob=this.paxObj[j].dob;

                // }

                if (
                  pdob[i] == "ADT" &&
                  pPaxList[j].paxType == "ADT" &&
                  pPaxList[j].dob == null
                ) {
                  retValue = false;
                  this.scrollToElement("scrollTo" + j);
                  break;
                } else {
                  retValue = true;
                }
                if (
                  pdob[i] == "CHD" &&
                  pPaxList[j].paxType == "CHD" &&
                  pPaxList[j].dob == null
                ) {
                  retValue = false;
                  this.scrollToElement("scrollTo" + j);
                  break;
                } else {
                  retValue = true;
                }
                if (
                  pdob[i] == "INF" &&
                  pPaxList[j].paxType == "INF" &&
                  pPaxList[j].dob == null
                ) {
                  retValue = false;
                  this.scrollToElement("scrollTo" + j);
                  break;
                } else {
                  retValue = true;
                }
                //  }
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in toCheckPaxDob",
          err.toString(),
          "toCheckPaxDob",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toCheckExpryDate(pExpry, pPaxList) {
      let retValue = true;
      let selExpryDate;
      try {
        if (BaseConfiguration.isDebug) console.log("toCheckExpryDate");
        if (this.sExpryDate != null && this.sExpryDate.length != 0) {
          selExpryDate = this.sExpryDate;
        }
        for (let index = 0; index < pPaxList.length - 2; index++) {
          if (selExpryDate && selExpryDate[index] != undefined) {
            pPaxList[index].expiryDate = selExpryDate[index];
          } else {
            pPaxList[index].expiryDate = null;
          }

          if (
            (pPaxList[index].idType.code == ID_TYPE.PASSPORT &&
              pPaxList[index].idNo != null &&
              pPaxList[index].idNo != "" &&
              pPaxList[index].expiryDate == null) ||
            (pPaxList[index].idType.code == ID_TYPE.PASSPORT &&
              (pPaxList[index].idNo == null || pPaxList[index].idNo == "") &&
              pPaxList[index].expiryDate != null)
          ) {
            retValue = false;
            this.scrollToElement("scrollTo" + index);
            break;
          } else {
            retValue = true;
          }
        }
        if (pExpry.length != 0 && pPaxList.length != 0) {
          for (let i = 0; i < pExpry.length; i++) {
            for (let j = 0; j < pPaxList.length - 2; j++) {
              if (retValue == true) {
                if (
                  pExpry[i] == "ADT" &&
                  pPaxList[j].paxType == "ADT" &&
                  pPaxList[j].idType.code == ID_TYPE.PASSPORT &&
                  pPaxList[j].expiryDate == null
                ) {
                  retValue = false;
                  this.scrollToElement("scrollTo" + j);
                  break;
                } else {
                  retValue = true;
                }
                if (
                  pExpry[i] == "CHD" &&
                  pPaxList[j].paxType == "CHD" &&
                  pPaxList[j].idType.code == ID_TYPE.PASSPORT &&
                  pPaxList[j].expiryDate == null
                ) {
                  retValue = false;
                  this.scrollToElement("scrollTo" + j);
                  break;
                } else {
                  retValue = true;
                }
                if (
                  pExpry[i] == "INF" &&
                  pPaxList[j].paxType == "INF" &&
                  pPaxList[j].idType.code == ID_TYPE.PASSPORT &&
                  pPaxList[j].expiryDate == null
                ) {
                  retValue = false;
                  this.scrollToElement("scrollTo" + j);
                  break;
                } else {
                  retValue = true;
                }
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in toCheckExpryDate",
          err.toString(),
          "toCheckExpryDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    paxPageSubmitted() {
      let dobOf = [];
      let expryDte = [];
      let isValidated = false;
      let isValidExpry = false;
      let valLs = [];

      try {
        if (BaseConfiguration.isDebug) console.log("paxPageSubmitted");

        this.SET_EXPRY_DATE(this.selExpryDate);
        this.SET_SEL_DOB(this.selDob);
        if (this.svaldLs != null) {
          valLs = this.svaldLs;
        } else {
          valLs = this.passenger.validation;
        }
        if (valLs[0].dobMandateRule.required) {
          dobOf.push("ADT");
        }
        if (valLs[1].dobMandateRule.required) {
          dobOf.push("CHD");
        }
        if (valLs[2].dobMandateRule.required) {
          dobOf.push("INF");
        }
        if (valLs[0].expryDateMandatoryRule.required) {
          expryDte.push("ADT");
        }
        if (valLs[1].expryDateMandatoryRule.required) {
          expryDte.push("CHD");
        }
        if (valLs[2].expryDateMandatoryRule.required) {
          expryDte.push("INF");
        }
        isValidExpry = this.toCheckExpryDate(expryDte, this.passenger.paxList);
        isValidated = this.toCheckPaxDob(dobOf, this.passenger.paxList);
        if (isValidated && isValidExpry) {
          // if(isValidated ) {
          let isVal = this.isValidPaxObj(this.passenger.paxList);

          if (isVal == true) {
            let isNameVal = this.toComparePaxNames(this.passenger.paxList);

            let isIDVal = this.toComparePaxIDNo(this.passenger.paxList);
            if (isIDVal == true && isNameVal == true) {
              this.valMsg = null;

              this.SET_PAX_LIST(this.passenger.paxList);
              updateDataEdited(false);

              navigate(PATHNAME.HOTEL_PAYMENT_PAGE,this.$router.currentRoute.query);
              ///api
            } else {
              //  this.toDisable = true;
              // this.valMsg = this.$t('passInfo.sameId')
            }
          } else {
            // this.toDisable = true;
            // this.valMsg = this.$t('passInfo.required')
          }
        } else {
          this.toDisable = true;
          for (let i = 0; i < this.passenger.paxList.length - 2; i++) {
            this.passenger.paxList[i].dob = this.getDefaultDob(
              this.passenger.paxList[i]
            );
            this.passenger.paxList[i].expiryDate = this.getDefaultExpiryDate();
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in submitted",
          err.toString(),
          "submitted",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getRules(pPaxType) {
      let retValue = null;

      try {
        if (pPaxType) {
          for (let i = 0; i < this.passenger.validation.length; i++) {
            // var paxValid = cloneData(this.passenger.validation[i]);
            if (this.passenger.validation[i].paxType == pPaxType) {
              retValue = this.passenger.validation[i];
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAXPAGE,
          "error in getRules",
          err.toString(),
          "getRules",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // console.log(retValue);

      return retValue;
    }
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.PAXPAGE);
  },

  beforeDestroy() {
    this.$root.$emit("toggle-sidebar-minimize", true);

    removeClassBody();
  }
};
</script>
